
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...catchall]",
      function () {
        return require("private-next-pages/[...catchall]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...catchall]"])
      });
    }
  